import type { PromotePageState } from './types';

export type InitialStateParams = {
	email: string;
	name: string;
	firstName: string;
	lastName: string;
	isPublic: boolean;
	isSecureGuest: boolean;
	prefilledWithGuestData?: boolean;
};

export function initialState({
	email,
	name,
	firstName,
	lastName,
	isPublic,
	isSecureGuest,
	prefilledWithGuestData,
}: InitialStateParams): PromotePageState {
	return {
		amount: 0,
		email: email || '',
		formState: { status: 'ready' },
		firstName,
		hasNewCreditCardData: false,
		isPublic,
		lastName,
		name,
		paymentMethodSaveOptions: {
			shouldSavePaymentMethod: !isSecureGuest,
			usage: 'ON_SESSION',
		},
		usingSavedPaymentMethod: false,
		validationErrors: null,
		prefilledWithGuestData,
	};
}
